import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { STOCK } from '../../lib/images';

const capabilities = [
  {
    name: 'Venture Studio',
    line: 'From possibility to enterprise',
    desc: 'InnovVentures, where opportunities are identified, concepts are shaped and new businesses are built, hands-on from within.',
    to: '/initiatives/venture-studio',
    image: STOCK.innovventures,
  },
  {
    name: 'InnovAce',
    line: 'Accelerating ambition into scale',
    desc: 'An intensive 18-month accelerator for founders and ventures ready to move from potential to measurable growth.',
    to: '/innovace',
    image: STOCK.innovace,
  },
  {
    name: 'InnovIdea',
    line: 'Ideas deserve an identity powerful enough to travel',
    desc: 'Brand, communication and growth, transforming business ideas into brands that can be understood, experienced and remembered.',
    to: '/innovidea',
    image: STOCK.innovidea,
  },
  {
    name: 'InnovVeda.ai',
    line: 'Technology to scale and expand horizons',
    desc: 'Technology and AI development, translating business ideas into intelligent, scalable digital products and infrastructure.',
    to: '/innoveda',
    image: STOCK.innoveda,
  },
];

export default function Capabilities() {
  return (
    <section id="capabilities" className="relative bg-[#08080a] py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="reveal-up grid lg:grid-cols-12 gap-8 lg:gap-14 items-start">
          <div className="lg:col-span-5">
            <h2 className="font-semibold tracking-tight text-white text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] leading-[1.05]">
              Built to <span className="text-[#d42b92]">Build</span>.
            </h2>
            <p className="mt-6 text-white/80 text-lg sm:text-xl leading-relaxed font-medium italic">
              Great ventures need more than a great idea. They need the right strategy, identity, technology, capabilities, networks and momentum, working together at the right time.
            </p>
          </div>

          <div className="lg:col-span-7 space-y-5 text-white/60 text-base sm:text-lg leading-relaxed ">
            <p>
              InnovHer brings these critical building blocks into one interconnected venture-building
              ecosystem. Through its Venture Studio, accelerator, brand and growth practice, and
              technology arm, InnovHer works across different stages of the entrepreneurial journey,
              from discovering opportunities and building new ventures to strengthening existing
              businesses for their next phase of growth.
            </p>
            <p>
              Each platform brings specialized expertise. Together, they create an integrated support
              mechanism designed to build stronger ventures, faster, with focus and intent.
            </p>
          </div>
        </div>

        <div className="mt-14 lg:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {capabilities.map((c, i) => (
            <Link
              key={c.to}
              to={c.to}
              className="reveal-up group rounded-3xl border border-white/10 overflow-hidden bg-white/[0.02] hover:border-[#d42b92]/60 transition-colors flex flex-col h-full"
            >
              <div className="h-44 sm:h-48 overflow-hidden shrink-0">
                <img
                  src={c.image}
                  alt=""
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                {/* <div className="text-[11px] tracking-[0.2em] text-[#ff8ec5]">0{i + 1}</div> */}
                <h3 className="mt-3 text-xl font-semibold text-white">{c.name}</h3>
                <p className="mt-1.5 text-sm text-[#ff8ec5]/90 font-medium">{c.line}</p>
                <p className="mt-3 text-sm text-white/50 leading-relaxed flex-1">{c.desc}</p>
                {/* <div className="mt-6 flex items-center gap-1.5 text-xs uppercase tracking-wider text-white/60 group-hover:text-[#ff8ec5] transition-colors">
                  Explore <ArrowUpRight className="w-3.5 h-3.5" />
                </div> */}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
